<template>
  <tree-node
    v-if="inflatedModel"
    :model="inflatedModel"
    :simple="simple"
    @nodeSelected="$emit('node:selected', $event)"
    @nodeExpanded="$emit('node:expanded', $event)"
    @nodeUpdated="$emit('tree:updated', $event)">
    <template
      v-if="!simple"
      slot-scope="{ node }">
      <slot :node="node" />
    </template>
  </tree-node>
</template>

<script>
import treeNode from './treeNode.vue'
import Node from '@/node'
import { initNodeData, getUsageType } from '@/utils'
import { EventBus } from '@/bus.js';

export default {
  created() {
    EventBus.$on('reset-tree', data => {
      this.root = null;
      this.proximateGoalTitle = '...................'
    });
    EventBus.$on('updated-proximate-goal', data => {
      this.proximateGoalTitle = data
    });
  },
  name: 'Tree',
  props: {
    model: {
      type: Object,
      default: () => ({
        label: 'The Problem',
        data: null,
        siblings: []
      })
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  components: {
    treeNode
  },
  data: () => ({
    inflatedModel: null,
    root: null,
    proximateGoalTitle: '...................'
  }),
    methods: {
    modelUpdated () {
      // Inflate the model
        this.inflatedModel = new Node(this.model)

        if (this.inflatedModel.root.siblings.length === 0 && getUsageType() === 2) {
          this.inflatedModel.root.siblings = []
          //console.log('modelUpdated ')
          this.root = this.inflatedModel
          const proximateGoal = {
              label: this.proximateGoalTitle,
              data: initNodeData(),
              goalNode: true,
              proxGoal: true,
              fresh: true
          }

          const distalGoal = {
              label: '...................',
              data: initNodeData(),
              goalNode: true,
              proxGoal: false,
              fresh: true
             }
         
          this.inflatedModel.appendSibling(proximateGoal, true)
          this.inflatedModel.appendSibling(distalGoal, true)
          //this.model.siblings = this.inflatedModel.siblings
        }
      /*if (this.inflatedModel.parent === null && getUsageType() === 2) {
        const goal = {
          label: 'The Goal',
          data: initNodeData(),
          goalNode: true,
          fresh: true
         }
         
        console.log('modelUpdated ' + goal.label || '...rename me...')
        console.log(goal.goalNode === true ? 'Yes' : 'No')

        this.inflatedModel.append(goal, true)
      }*/
      //console.log('----------this.model.usageType ' + this.model.usageType) 
      this.inflatedModel.on('updated', (tree) => {
        this.$emit('tree:updated', tree)
      })



      // Pass inflated tree to the parent the parent
      this.$emit('tree:inflated', {
        inflated: this.inflatedModel,
        deflated: this.model
      })
    }
  },
  watch: {
    model () {
      this.modelUpdated()
    }
  }
}
</script>
